/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect,  } from "react";
import { Redirect } from "react-router";
import { useLocation } from "react-router-dom";
import { STATES } from "../../model/matchmaking";
import createRedisMatchMaking, { setRedisMatchMaking } from "../../utils/redisPubSub";
import { useMatchmaking } from "../../viewmodel/hooks/getMatchmaking";
import { useProfile } from "../../viewmodel/hooks/getProfile";
import { UserContext } from "../../viewmodel/providers/user-context";
import { getUserInfo } from "../../viewmodel/providers/userInfo";
import "../css/MenuStart.css";
import { AcceptOpponentScreen } from "./AcceptOpponent";
import ReplayLoading from "./WaitingLoading";

import routes from "../../utils/routes.json";
import MainScreen from "./templates/MainScreen";
import { makeStyles } from "@material-ui/core";

type locationState = {
    categoryIds: string[],
}

const useStyles = makeStyles((theme) => ({
    centerText: {
        textAlign: "center",
    },
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    centerVertical: {
        marginTop: "auto",
        marginBottom: "auto",
    },
}));

export default function MatchMaking(): JSX.Element {

    const [state, setMatchMakingState, setOpponent, setChannelId] = useMatchmaking();
    const [showMessage, setShowMessage]= useState (false);
    const userId: string = React.useContext(UserContext).userId;
    const classes = useStyles();

    const location: locationState = useLocation<locationState>().state;

    setRedisMatchMaking(state);

    useEffect(() => {
        const redisMatchmaking
            = createRedisMatchMaking(state, setMatchMakingState, setOpponent, setChannelId, userId, location.categoryIds);
        const timer = setTimeout(() => {
            setShowMessage(true);
        }, 100000);
        if (state.state === STATES.CONNECTING)
            redisMatchmaking.sendLookForGame();
        return () => {
            clearTimeout(timer);
            redisMatchmaking.close();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [opponent, setProfileOpponent] = useProfile();
    useEffect(() => {
        if (state.opponentId)
            getUserInfo(state.opponentId, setProfileOpponent);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.opponentId]);

    if (!location)
        return <Redirect to={routes.categories} />;

    let component;

    if (state.state === STATES.CONNECTING || state.state === STATES.LOOK || state.state === STATES.WAIT_FOR_REQUEST)
        component = <AcceptOpponentScreen loaded={false} />;
    else if (state.state === STATES.CONFIRM)
        component = <AcceptOpponentScreen loaded={true} user={opponent.user} />;
    else if (state.state === STATES.WAITING_FOR_OPPONENT)
        component = <ReplayLoading user={opponent.user} />;
    else if (state.state === STATES.SEND_START_GAME)
        component = <ReplayLoading user={opponent.user} />;
    else if (state.state === STATES.START_GAME)
        component =
            <Redirect
                to={{
                    pathname: routes.game,
                    state: {
                        channelId: state.channelId,
                        opponentId: state.opponentId,
                        userId: userId,
                        categoryIds: location.categoryIds,
                    },
                }}
            />;
    else
        component = <AcceptOpponentScreen loaded={false} />;

    if (showMessage){
        return(
        <MainScreen lower={false} back={true}>
            <h1 className={`${classes.centerText} ${classes.centerHorizontal} ${classes.centerVertical}`}> Sem adversário. Tente mais tarde!</h1>
        </MainScreen>
        )
    }else{
        return(component)
    }
}
